import React from 'react'
import {Button} from './Button'
import {ArrowRight} from './icons'
import {signupModalHref} from './constants'

function SparkIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3v3M12 18v3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M3 12h3M18 12h3M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
    </svg>
  )
}

function BadgeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2 14.5 5l3.7.6-2.7 2.6.7 3.7L12 10l-3.2 1.9.7-3.7L6.8 5.6 10.5 5 12 2z" />
      <path d="M12 12v9" />
      <path d="M9 18l3 3 3-3" />
    </svg>
  )
}

function TeamIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M3 20c0-3 3-5 6-5s6 2 6 5" />
      <path d="M14 20c0-2.2 1.6-4 3-4s4 1.8 4 4" />
    </svg>
  )
}

const benefits = [
  {
    icon: <SparkIcon />,
    title: 'Buyers come in better-informed',
    copy: 'Complete Listing Packages with disclosures and video tour mean fewer questions and cleaner offers.',
  },
  {
    icon: <BadgeIcon />,
    title: 'You stay the expert',
    copy: 'Branded reports keep you front-and-center, so you are always the one delivering the update.',
  },
  {
    icon: <TeamIcon />,
    title: 'Your whole team, one place',
    copy: 'TCs, assistants, and brokers all work from the same secure listing with the permissions you set.',
  },
]

function WhyHomeLightV2() {
  return (
    <section className="hlm-why">
      <div className="hlm-container hlm-why-content">
        <div className="hlm-why-pill">
          <span className="hlm-why-pill-dot" />
          Why HomeLight
        </div>
        <div className="hlm-why-row">
          <h2>
            Built for the way <span>top producers actually work.</span>
          </h2>
          <div className="hlm-why-cta">
            <Button href={signupModalHref} size="lg">
              Try 14 days free
              <ArrowRight />
            </Button>
            <div className="hlm-why-cta-sub">No credit card required</div>
          </div>
        </div>
        <div className="hlm-why-benefits">
          {benefits.map(benefit => (
            <div className="hlm-benefit" key={benefit.title}>
              <div className="hlm-benefit-icon">{benefit.icon}</div>
              <div className="hlm-benefit-title">{benefit.title}</div>
              <div className="hlm-benefit-copy">{benefit.copy}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyHomeLightV2
